import { useState } from 'react'

import type { Link } from '~publish/legacy/composer/composer/entities/factories'
import ComposerStore from '~publish/legacy/composer/composer/stores/ComposerStore'
import Scraper from '~publish/legacy/composer/composer/utils/Scraper'
import { logError } from '~publish/legacy/utils/logError'

export const useLinkPreview = (
  isTwitterPreview: boolean,
): [
  Link | null,
  (link: string | null, updatePreview: boolean) => void,
  (linkPreview: Link | null) => void,
  (isDataLoaded: boolean) => void,
  boolean,
  Link | null,
] => {
  const [linkPreview, setLinkPreview] = useState<Link | null>(null)
  const [scrapedResult, setScrapedData] = useState<Link | null>(null)
  const [isDataLoaded, setIsDataLoaded] = useState<boolean>(false)

  const scrapeUrl = (link: string | null, updatePreview: boolean): void => {
    if (link && link !== '') {
      const canonicalUrl = ComposerStore.getCanonicalUrl(link)

      void Scraper.scrape(canonicalUrl, isTwitterPreview)
        .then(
          (scrapedData): Link => ({
            url: canonicalUrl,
            title: scrapedData.title || '',
            description: scrapedData.description || '',
            thumbnail:
              Array.isArray(scrapedData.images) && scrapedData.images.length > 0
                ? {
                    url: scrapedData.images[0].url,
                    width: scrapedData.images[0].width,
                    height: scrapedData.images[0].height,
                    mediaType: scrapedData.images[0].type,
                  }
                : null,
            expandedUrl: scrapedData.canonicalUrl,
            thumbnailHttps: null,
            availableThumbnails: scrapedData.images?.map((image) => image.url),
            scrapingError: undefined,
            wasEdited: false,
          }),
        )
        .then((scrapedData) => {
          if (
            scrapedData.title ||
            scrapedData.description ||
            scrapedData.thumbnail
          ) {
            if (updatePreview) setLinkPreview(scrapedData)
            setScrapedData(scrapedData)
            setIsDataLoaded(true)
          }
          return undefined
        })
        .catch(logError)
    }
  }

  return [
    linkPreview,
    scrapeUrl,
    setLinkPreview,
    setIsDataLoaded,
    isDataLoaded,
    scrapedResult,
  ] as const
}
